import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { MetadataService } from '../../services/metadata.service';
import { Utils } from '../../services/util.service';
import { Subscription } from 'rxjs';
import { ChannelsService } from '../../services/channels.service';

@Component({
    selector: 'app-video-thumb-shared',
    template: '',
})
export class VideoThumbSharedComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input() media: any;
    @Input() thumbnailType: string;
    @Input() dstart: boolean;
    @Input() seasonId: number;
    @Input() channelImage: string;
    @Input() recommendationId: string;
    @Input() creatorTeam: any;

    @Output() focused = new EventEmitter<void>();

    @ViewChild('thumb')
    thumb: ElementRef;


    newVideo: boolean = false;
    progress: number;
    width = 0;
    timeAgo: string
    routerLink: string[];
    watchSubscription: Subscription;
    position: string = '0:00';
    continueWatchingSeconds: number = 0;

    constructor(public readonly changeDetector: ChangeDetectorRef,
                public readonly metadataService: MetadataService,
                public readonly utils: Utils,
                public readonly channelService: ChannelsService) {
    }

    async ngOnInit() {
        if (!this.media.title && this.media.mediaId) {
            const res = await this.metadataService.getMetadata(this.media.mediaId).toPromise();
            this.media.title = res.metadata.title;
            this.media.shortDescription = res.metadata.shortDescription;
            this.timeAgo = this.utils.getTime(this.media.datePublished);
        } else {
            if (this.media.images) {
                this.media.image = this.thumbnailType === 'vertical' ? this.media.images.find(x => x.type === 'packshot')?.url : this.media.images.find(x => x.type === 'thumbnail')?.url;
                this.media.channelBadgeUrl = this.media.images.find(x => x.type === 'channel-badge')?.url;
                this.media.previewImage = this.media.images.find(x => x.type === 'media-preview')?.url;
            }
            this.timeAgo = this.utils.getTime(this.media.datePublished);
        }

        this.routerLink = this.getRouterLink();

        this.watchSubscription = this.channelService.watchHistory().subscribe(res => {
            this.watchHistory(res);
        });
    }

    ngAfterViewInit() {
        this.width = Math.ceil(this.thumb?.nativeElement.offsetWidth);
        this.changeDetector.detectChanges();
    }

    ngOnDestroy() {
        if (this.watchSubscription) {
            this.watchSubscription.unsubscribe();
        }
    }

    checkNew() {
        this.newVideo = false;
        const timestamp = new Date().getTime() - (7 * 24 * 60 * 60 * 1000);
        const releaseTime = new Date(this.media.datePublished).getTime();

        if (releaseTime > timestamp && (!this.progress || this.progress <= 0)) {
            this.newVideo = true;
        }
    }

    watchHistory(history: any[]) {
        if (history && history.length > 0) {
            let result = history.find(f => f.mediaId == this.media.mediaId);
            if (result) {
                this.progress = result.percentage;
                this.position = result.position;
                let hms: string[] = this.position.split(':');
                this.continueWatchingSeconds = hms.length > 2 ? (+hms[0]) * 60 * 60 + (+hms[1]) * 60 + (+hms[2]) : (+hms[0]) * 60 + (+hms[1])
            }
            this.checkNew();
        }
    }

    private getRouterLink(): string[] {
        if (this.creatorTeam) {
            return ['/creators', this.creatorTeam.id];
        }

        if (this.media.creatorTeamId && (!this.media.mediaId && !this.media.seasonId)) {
            return ['/creators', this.media?.creatorTeamId?.toString()];
        }
        if (this.media.seasonId !== undefined) {
            return ['/season', this.media.seasonId];
        }
        if (this.media.livestreamId !== undefined) {
            return ['/live', this.media.livestreamId];
        }
        return ['/video', this.media.mediaId,];
    }

    checkXboxKey(event: KeyboardEvent): string {
        let key = event.key;
        if (key === 'Unidentified') {
            const xboxKeyMap: Record<number, string> = {
                37:  'ArrowLeft',
                205: 'ArrowLeft',

                206:  'ArrowRight',
                39: 'ArrowRight',

                203:  'ArrowUp',
                38: 'ArrowUp',

                204:  'ArrowDown',
                40: 'ArrowDown',

                195: 'Enter',

                27: 'BackspaceXbox'
            };

            key = xboxKeyMap[event.keyCode] || xboxKeyMap[event.which] || key;
        }
        return key;
    }
}
